import type { Rule } from '@rc-component/form/lib/interface';
import { saveAs } from 'file-saver';
import { loadUser } from '../oidcConfig.ts';

export { blobToDataUrl } from '@medcom/shared-ui/utils/helpers.ts';

export const stripTypename = <T>(object: T): T => {
  // @ts-expect-error __typename not defined
  const { __typename, ...result } = object;
  return result as T;
};

export const saveUrl = async (url: string, defaultFilename?: string, onError: () => void = () => {}) => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      saveAs(blob, response.headers.get('x-amz-meta-original_name') ?? defaultFilename);
    } else {
      onError();
    }
  } catch {
    onError();
  }
};

export const serverSideEmailRule: Rule = {
  validator: async (_, value) => {
    if (!value) {
      return Promise.resolve();
    }

    const response = await fetch(`${window._env_.API_URL}/rest/validation/email`, {
      method: 'POST',
      headers: { authorization: `Bearer ${loadUser()?.access_token}`, 'content-type': 'application/json' },
      body: JSON.stringify({ email: value }),
    });
    if (!response.ok) {
      return Promise.reject('Serverantwort nicht OK');
    }
    const isValid = await response.json();
    return isValid ? Promise.resolve() : Promise.reject('Die E-Mail-Adresse ist ungültig');
  },
};
